const colors = {
  $dataStandardSingle: "rgb(28,105,232)",
  $dataStandardSentimentNegative: "rgb(223,82,52)",
  $dataStandardSentimentNotice: "rgb(228,180,48)",
  $dataStandardSentimentPositive: "rgb(57,166,82)",
  $dataCategorical10: "rgb(242,123,97)",
  $dataCategorical11: "rgb(197,201,72)",
  $dataCategorical12: "rgb(46,175,188)",
  $dataCategorical13: "rgb(101,202,125)",
  $dataCategorical14: "rgb(72, 121, 26)",
  $dataCategorical15: "rgb(146, 72, 30)",
  $dataCategorical01: "rgb(130,52,218)",
  $dataCategorical02: "rgb(19,141,155)",
  $dataCategorical03: "rgb(209,44,115)",
  $dataCategorical04: "rgb(57,166,82)",
  $dataCategorical05: "rgb(223,82,52)",
  $dataCategorical06: "rgb(252,199,58)",
  $dataCategorical07: "rgb(21,136,213)",
  $dataCategorical08: "rgb(233,153,51)",
  $dataCategorical09: "rgb(54,61,209)",
  $dataSequentialSingle01: "rgb(18,88,210)",
  $dataSequentialSingle02: "rgb(28,105,232)",
  $dataSequentialSingle03: "rgb(60,131,239)",
  $dataSequentialSingle04: "rgb(106,162,244)",
  $dataSequentialSingle05: "rgb(156,192,247)",
  $dataSequentialSingle06: "rgb(191,216,250)",
  $dataSequentialSingle07: "rgb(217,232,253)",
  $dataSequentialGray01: "rgb(61, 61, 61)",
  $dataSequentialGray02: "rgb(108, 108, 108)",
  $dataSequentialGray03: "rgb(135, 134, 134)",
  $dataSequentialGray04: "rgb(170, 170, 170)",
  $dataSequentialGray05: "rgb(221, 221, 221)",
  $dataSequentialGray06: "rgb(238, 238, 238)",
  $dataSequentialPurple01: "rgb(130,52,218)",
  $dataSequentialPurple02: "rgb(145,66,236)",
  $dataSequentialPurple03: "rgb(168,98,242)",
  $dataSequentialPurple04: "rgb(185,130,242)",
  $dataSequentialPurple05: "rgb(209,170,249)",
  $dataSequentialPurple06: "rgb(230,203,255)",
  $dataSequentialPurple07: "rgb(234,220,252)",
  $dataSequentialTeal01: "rgb(19,141,155)",
  $dataSequentialTeal02: "rgb(27,157,175)",
  $dataSequentialTeal03: "rgb(46,175,188)",
  $dataSequentialTeal04: "rgb(90,201,210)",
  $dataSequentialTeal05: "rgb(137,218,224)",
  $dataSequentialTeal06: "rgb(177,231,237)",
  $dataSequentialTeal07: "rgb(207,242,243)",
  $dataSequentialPink01: "rgb(209,44,115)",
  $dataSequentialPink02: "rgb(224,57,117)",
  $dataSequentialPink03: "rgb(244,84,152)",
  $dataSequentialPink04: "rgb(249,126,179)",
  $dataSequentialPink05: "rgb(252,166,203)",
  $dataSequentialPink06: "rgb(254,197,222)",
  $dataSequentialPink07: "rgb(255,220,236)",
  $dataSequentialGreen01: "rgb(57,166,82)",
  $dataSequentialGreen02: "rgb(70,183,96)",
  $dataSequentialGreen03: "rgb(101,202,125)",
  $dataSequentialGreen04: "rgb(139,215,157)",
  $dataSequentialGreen05: "rgb(177,229,191)",
  $dataSequentialGreen06: "rgb(206,238,214)",
  $dataSequentialGreen07: "rgb(226,246,230)",
  $dataSequentialScarlet01: "rgb(223,82,52)",
  $dataSequentialScarlet02: "rgb(239,95,62)",
  $dataSequentialScarlet03: "rgb(242,123,97)",
  $dataSequentialScarlet04: "rgb(246,154,134)",
  $dataSequentialScarlet05: "rgb(249,190,178)",
  $dataSequentialScarlet06: "rgb(251,213,204)",
  $dataSequentialScarlet07: "rgb(253,230,226)",
  $dataSequentialYellow01: "rgb(228,180,48)",
  $dataSequentialYellow02: "rgb(252,199,58)",
  $dataSequentialYellow03: "rgb(254,214,106)",
  $dataSequentialYellow04: "rgb(255,228,156)",
  $dataSequentialYellow05: "rgb(255,238,190)",
  $dataSequentialYellow06: "rgb(255,244,214)",
  $dataSequentialYellow07: "rgb(255,250,234)",
  $dataSequentialCyan01: "rgb(13,118,189)",
  $dataSequentialCyan02: "rgb(21,136,213)",
  $dataSequentialCyan03: "rgb(87,182,233)",
  $dataSequentialCyan04: "rgb(87,182,233)",
  $dataSequentialCyan05: "rgb(138,207,241)",
  $dataSequentialCyan06: "rgb(178,223,245)",
  $dataSequentialCyan07: "rgb(207,237,250)",
  $dataSequentialGold01: "rgb(233,153,51)",
  $dataSequentialGold02: "rgb(255,173,72)",
  $dataSequentialGold03: "rgb(255,191,98)",
  $dataSequentialGold04: "rgb(255,207,138)",
  $dataSequentialGold05: "rgb(255,222,170)",
  $dataSequentialGold06: "rgb(255,233,202)",
  $dataSequentialGold07: "rgb(255,242,220)",
  $dataSequentialIndigo01: "rgb(54,61,209)",
  $dataSequentialIndigo02: "rgb(70,78,231)",
  $dataSequentialIndigo03: "rgb(97,102,233)",
  $dataSequentialIndigo04: "rgb(135,140,243)",
  $dataSequentialIndigo05: "rgb(176,179,244)",
  $dataSequentialIndigo06: "rgb(205,207,248)",
  $dataSequentialIndigo07: "rgb(224,223,251)",
  $dataSequentialOlive01: "rgb(179,184,59)",
  $dataSequentialOlive02: "rgb(197,201,72)",
  $dataSequentialOlive03: "rgb(211,214,105)",
  $dataSequentialOlive04: "rgb(222,224,142)",
  $dataSequentialOlive05: "rgb(233,234,179)",
  $dataSequentialOlive06: "rgb(241,242,207)",
  $dataSequentialOlive07: "rgb(247,247,226)",
  $datavizGray10: "rgb(44, 44, 48)",
  $datavizGray11: "rgb(34, 34, 37)",
  $datavizGray12: "rgb(25, 24, 27)",
  $datavizGray13: "rgb(15, 15, 16)",
  $datavizGray00: "rgb(239, 239, 240)",
  $datavizGray01: "rgb(223, 223, 226)",
  $datavizGray02: "rgb(202, 202, 206)",
  $datavizGray03: "rgb(181, 181, 186)",
  $datavizGray04: "rgb(160, 160, 167)",
  $datavizGray05: "rgb(139, 138, 147)",
  $datavizGray06: "rgb(118, 118, 127)",
  $datavizGray07: "rgb(98, 98, 106)",
  $datavizGray08: "rgb(79, 78, 85)",
  $datavizGray09: "rgb(59, 59, 64)",
  $datavizMagentaRed10: "rgb(72, 20, 25)",
  $datavizMagentaRed11: "rgb(56, 16, 20)",
  $datavizMagentaRed12: "rgb(40, 11, 14)",
  $datavizMagentaRed13: "rgb(24, 7, 8)",
  $datavizMagentaRed00: "rgb(248, 231, 233)",
  $datavizMagentaRed01: "rgb(242, 207, 211)",
  $datavizMagentaRed02: "rgb(233, 175, 181)",
  $datavizMagentaRed03: "rgb(224, 144, 152)",
  $datavizMagentaRed04: "rgb(215, 112, 122)",
  $datavizMagentaRed05: "rgb(206, 80, 93)",
  $datavizMagentaRed06: "rgb(191, 54, 68)",
  $datavizMagentaRed07: "rgb(159, 45, 56)",
  $datavizMagentaRed08: "rgb(127, 36, 45)",
  $datavizMagentaRed09: "rgb(95, 27, 34)",
  $datavizRedOrange10: "rgb(72, 33, 20)",
  $datavizRedOrange11: "rgb(56, 26, 16)",
  $datavizRedOrange12: "rgb(40, 18, 11)",
  $datavizRedOrange13: "rgb(24, 11, 7)",
  $datavizRedOrange00: "rgb(248, 235, 231)",
  $datavizRedOrange01: "rgb(242, 216, 207)",
  $datavizRedOrange02: "rgb(233, 190, 175)",
  $datavizRedOrange03: "rgb(224, 164, 144)",
  $datavizRedOrange04: "rgb(215, 137, 112)",
  $datavizRedOrange05: "rgb(206, 111, 80)",
  $datavizRedOrange06: "rgb(191, 88, 54)",
  $datavizRedOrange07: "rgb(159, 73, 45)",
  $datavizRedOrange08: "rgb(127, 59, 36)",
  $datavizRedOrange09: "rgb(95, 44, 27)",
  $datavizOrange10: "rgb(72, 46, 20)",
  $datavizOrange11: "rgb(56, 36, 16)",
  $datavizOrange12: "rgb(40, 26, 11)",
  $datavizOrange13: "rgb(24, 15, 7)",
  $datavizOrange00: "rgb(248, 240, 231)",
  $datavizOrange01: "rgb(242, 224, 207)",
  $datavizOrange02: "rgb(233, 204, 175)",
  $datavizOrange03: "rgb(224, 184, 144)",
  $datavizOrange04: "rgb(215, 163, 112)",
  $datavizOrange05: "rgb(206, 143, 80)",
  $datavizOrange06: "rgb(191, 122, 54)",
  $datavizOrange07: "rgb(159, 102, 45)",
  $datavizOrange08: "rgb(127, 82, 36)",
  $datavizOrange09: "rgb(95, 61, 27)",
  $datavizOrangeYellow10: "rgb(83, 64, 9)",
  $datavizOrangeYellow11: "rgb(64, 50, 7)",
  $datavizOrangeYellow12: "rgb(46, 36, 5)",
  $datavizOrangeYellow13: "rgb(28, 21, 3)",
  $datavizOrangeYellow00: "rgb(252, 246, 227)",
  $datavizOrangeYellow01: "rgb(249, 237, 200)",
  $datavizOrangeYellow02: "rgb(245, 224, 163)",
  $datavizOrangeYellow03: "rgb(241, 212, 126)",
  $datavizOrangeYellow04: "rgb(237, 200, 90)",
  $datavizOrangeYellow05: "rgb(233, 188, 53)",
  $datavizOrangeYellow06: "rgb(220, 171, 24)",
  $datavizOrangeYellow07: "rgb(184, 143, 20)",
  $datavizOrangeYellow08: "rgb(147, 114, 16)",
  $datavizOrangeYellow09: "rgb(110, 86, 12)",
  $datavizYellowLime10: "rgb(59, 72, 20)",
  $datavizYellowLime11: "rgb(46, 56, 16)",
  $datavizYellowLime12: "rgb(33, 40, 11)",
  $datavizYellowLime13: "rgb(20, 24, 7)",
  $datavizYellowLime00: "rgb(244, 248, 231)",
  $datavizYellowLime01: "rgb(233, 242, 207)",
  $datavizYellowLime02: "rgb(218, 233, 175)",
  $datavizYellowLime03: "rgb(204, 224, 144)",
  $datavizYellowLime04: "rgb(189, 215, 112)",
  $datavizYellowLime05: "rgb(174, 206, 80)",
  $datavizYellowLime06: "rgb(157, 191, 54)",
  $datavizYellowLime07: "rgb(131, 159, 45)",
  $datavizYellowLime08: "rgb(104, 127, 36)",
  $datavizYellowLime09: "rgb(78, 95, 27)",
  $datavizLimeGreen10: "rgb(35, 68, 24)",
  $datavizLimeGreen11: "rgb(27, 53, 19)",
  $datavizLimeGreen12: "rgb(19, 38, 13)",
  $datavizLimeGreen13: "rgb(12, 23, 8)",
  $datavizLimeGreen00: "rgb(236, 247, 232)",
  $datavizLimeGreen01: "rgb(217, 239, 210)",
  $datavizLimeGreen02: "rgb(192, 228, 180)",
  $datavizLimeGreen03: "rgb(166, 218, 149)",
  $datavizLimeGreen04: "rgb(141, 207, 119)",
  $datavizLimeGreen05: "rgb(116, 197, 89)",
  $datavizLimeGreen06: "rgb(93, 181, 64)",
  $datavizLimeGreen07: "rgb(78, 151, 53)",
  $datavizLimeGreen08: "rgb(62, 121, 42)",
  $datavizLimeGreen09: "rgb(47, 91, 32)",
  $datavizMintAqua10: "rgb(24, 68, 57)",
  $datavizMintAqua11: "rgb(19, 53, 44)",
  $datavizMintAqua12: "rgb(13, 38, 32)",
  $datavizMintAqua13: "rgb(8, 23, 19)",
  $datavizMintAqua00: "rgb(232, 247, 243)",
  $datavizMintAqua01: "rgb(210, 239, 232)",
  $datavizMintAqua02: "rgb(180, 228, 216)",
  $datavizMintAqua03: "rgb(149, 218, 201)",
  $datavizMintAqua04: "rgb(119, 207, 185)",
  $datavizMintAqua05: "rgb(89, 197, 170)",
  $datavizMintAqua06: "rgb(64, 181, 152)",
  $datavizMintAqua07: "rgb(53, 151, 126)",
  $datavizMintAqua08: "rgb(42, 121, 101)",
  $datavizMintAqua09: "rgb(32, 91, 76)",
  $datavizAquaBlue10: "rgb(20, 59, 72)",
  $datavizAquaBlue11: "rgb(16, 46, 56)",
  $datavizAquaBlue12: "rgb(11, 33, 40)",
  $datavizAquaBlue13: "rgb(7, 20, 24)",
  $datavizAquaBlue00: "rgb(231, 244, 248)",
  $datavizAquaBlue01: "rgb(207, 233, 242)",
  $datavizAquaBlue02: "rgb(175, 218, 233)",
  $datavizAquaBlue03: "rgb(144, 204, 224)",
  $datavizAquaBlue04: "rgb(112, 189, 215)",
  $datavizAquaBlue05: "rgb(80, 174, 206)",
  $datavizAquaBlue06: "rgb(54, 157, 191)",
  $datavizAquaBlue07: "rgb(45, 131, 159)",
  $datavizAquaBlue08: "rgb(36, 104, 127)",
  $datavizAquaBlue09: "rgb(27, 78, 95)",
  $datavizBlueViolet10: "rgb(20, 33, 72)",
  $datavizBlueViolet11: "rgb(16, 26, 56)",
  $datavizBlueViolet12: "rgb(11, 18, 40)",
  $datavizBlueViolet13: "rgb(7, 11, 24)",
  $datavizBlueViolet00: "rgb(231, 235, 248)",
  $datavizBlueViolet01: "rgb(207, 216, 242)",
  $datavizBlueViolet02: "rgb(175, 190, 233)",
  $datavizBlueViolet03: "rgb(144, 164, 224)",
  $datavizBlueViolet04: "rgb(112, 137, 215)",
  $datavizBlueViolet05: "rgb(80, 111, 206)",
  $datavizBlueViolet06: "rgb(54, 88, 191)",
  $datavizBlueViolet07: "rgb(45, 73, 159)",
  $datavizBlueViolet08: "rgb(36, 59, 127)",
  $datavizBlueViolet09: "rgb(27, 44, 95)",
  $datavizVioletPurple10: "rgb(35, 24, 68)",
  $datavizVioletPurple11: "rgb(27, 19, 53)",
  $datavizVioletPurple12: "rgb(19, 13, 38)",
  $datavizVioletPurple13: "rgb(12, 8, 23)",
  $datavizVioletPurple00: "rgb(236, 232, 247)",
  $datavizVioletPurple01: "rgb(217, 210, 239)",
  $datavizVioletPurple02: "rgb(192, 180, 228)",
  $datavizVioletPurple03: "rgb(166, 149, 218)",
  $datavizVioletPurple04: "rgb(141, 119, 207)",
  $datavizVioletPurple05: "rgb(116, 89, 197)",
  $datavizVioletPurple06: "rgb(93, 64, 181)",
  $datavizVioletPurple07: "rgb(78, 53, 151)",
  $datavizVioletPurple08: "rgb(62, 42, 121)",
  $datavizVioletPurple09: "rgb(47, 32, 91)",
  $datavizPurplePink10: "rgb(57, 24, 68)",
  $datavizPurplePink11: "rgb(44, 19, 53)",
  $datavizPurplePink12: "rgb(32, 13, 38)",
  $datavizPurplePink13: "rgb(19, 8, 23)",
  $datavizPurplePink00: "rgb(243, 232, 247)",
  $datavizPurplePink01: "rgb(232, 210, 239)",
  $datavizPurplePink02: "rgb(216, 180, 228)",
  $datavizPurplePink03: "rgb(201, 149, 218)",
  $datavizPurplePink04: "rgb(185, 119, 207)",
  $datavizPurplePink05: "rgb(170, 89, 197)",
  $datavizPurplePink06: "rgb(152, 64, 181)",
  $datavizPurplePink07: "rgb(126, 53, 151)",
  $datavizPurplePink08: "rgb(101, 42, 121)",
  $datavizPurplePink09: "rgb(76, 32, 91)",
  $datavizRedVivid10: "rgb(83, 9, 9)",
  $datavizRedVivid11: "rgb(64, 7, 7)",
  $datavizRedVivid12: "rgb(46, 5, 5)",
  $datavizRedVivid13: "rgb(28, 3, 3)",
  $datavizRedVivid00: "rgb(252, 227, 227)",
  $datavizRedVivid01: "rgb(249, 200, 200)",
  $datavizRedVivid02: "rgb(245, 163, 163)",
  $datavizRedVivid03: "rgb(241, 126, 126)",
  $datavizRedVivid04: "rgb(237, 90, 90)",
  $datavizRedVivid05: "rgb(233, 53, 53)",
  $datavizRedVivid06: "rgb(220, 24, 24)",
  $datavizRedVivid07: "rgb(184, 20, 20)",
  $datavizRedVivid08: "rgb(147, 16, 16)",
  $datavizRedVivid09: "rgb(110, 12, 12)",
  $datavizRedOrangeVivid10: "rgb(89, 24, 3)",
  $datavizRedOrangeVivid11: "rgb(69, 19, 2)",
  $datavizRedOrangeVivid12: "rgb(49, 14, 2)",
  $datavizRedOrangeVivid13: "rgb(30, 8, 1)",
  $datavizRedOrangeVivid00: "rgb(254, 233, 225)",
  $datavizRedOrangeVivid01: "rgb(253, 210, 196)",
  $datavizRedOrangeVivid02: "rgb(252, 180, 156)",
  $datavizRedOrangeVivid03: "rgb(251, 150, 116)",
  $datavizRedOrangeVivid04: "rgb(249, 120, 77)",
  $datavizRedOrangeVivid05: "rgb(248, 90, 37)",
  $datavizRedOrangeVivid06: "rgb(237, 65, 7)",
  $datavizRedOrangeVivid07: "rgb(198, 54, 6)",
  $datavizRedOrangeVivid08: "rgb(158, 43, 5)",
  $datavizRedOrangeVivid09: "rgb(119, 32, 4)",
  $datavizOrangeVivid10: "rgb(89, 46, 3)",
  $datavizOrangeVivid11: "rgb(69, 36, 2)",
  $datavizOrangeVivid12: "rgb(49, 26, 2)",
  $datavizOrangeVivid13: "rgb(30, 15, 1)",
  $datavizOrangeVivid00: "rgb(254, 240, 225)",
  $datavizOrangeVivid01: "rgb(253, 224, 196)",
  $datavizOrangeVivid02: "rgb(252, 204, 156)",
  $datavizOrangeVivid03: "rgb(251, 184, 116)",
  $datavizOrangeVivid04: "rgb(249, 163, 77)",
  $datavizOrangeVivid05: "rgb(248, 143, 37)",
  $datavizOrangeVivid06: "rgb(237, 122, 7)",
  $datavizOrangeVivid07: "rgb(198, 102, 6)",
  $datavizOrangeVivid08: "rgb(158, 82, 5)",
  $datavizOrangeVivid09: "rgb(119, 61, 4)",
  $datavizOrangeYellowVivid10: "rgb(89, 67, 3)",
  $datavizOrangeYellowVivid11: "rgb(69, 52, 2)",
  $datavizOrangeYellowVivid12: "rgb(49, 37, 2)",
  $datavizOrangeYellowVivid13: "rgb(30, 22, 1)",
  $datavizOrangeYellowVivid00: "rgb(254, 247, 225)",
  $datavizOrangeYellowVivid01: "rgb(253, 239, 196)",
  $datavizOrangeYellowVivid02: "rgb(252, 228, 156)",
  $datavizOrangeYellowVivid03: "rgb(251, 217, 116)",
  $datavizOrangeYellowVivid04: "rgb(249, 206, 77)",
  $datavizOrangeYellowVivid05: "rgb(248, 196, 37)",
  $datavizOrangeYellowVivid06: "rgb(237, 180, 7)",
  $datavizOrangeYellowVivid07: "rgb(198, 150, 6)",
  $datavizOrangeYellowVivid08: "rgb(158, 120, 5)",
  $datavizOrangeYellowVivid09: "rgb(119, 90, 4)",
  $datavizGreenMintVivid10: "rgb(17, 75, 31)",
  $datavizGreenMintVivid11: "rgb(13, 59, 24)",
  $datavizGreenMintVivid12: "rgb(9, 42, 17)",
  $datavizGreenMintVivid13: "rgb(6, 25, 10)",
  $datavizGreenMintVivid00: "rgb(230, 249, 235)",
  $datavizGreenMintVivid01: "rgb(205, 244, 215)",
  $datavizGreenMintVivid02: "rgb(171, 237, 188)",
  $datavizGreenMintVivid03: "rgb(138, 229, 161)",
  $datavizGreenMintVivid04: "rgb(104, 222, 134)",
  $datavizGreenMintVivid05: "rgb(71, 215, 107)",
  $datavizGreenMintVivid06: "rgb(44, 201, 83)",
  $datavizGreenMintVivid07: "rgb(37, 167, 69)",
  $datavizGreenMintVivid08: "rgb(29, 134, 55)",
  $datavizGreenMintVivid09: "rgb(22, 100, 42)",
  $datavizAquaBlueVivid10: "rgb(6, 66, 86)",
  $datavizAquaBlueVivid11: "rgb(4, 51, 67)",
  $datavizAquaBlueVivid12: "rgb(3, 37, 48)",
  $datavizAquaBlueVivid13: "rgb(2, 22, 29)",
  $datavizAquaBlueVivid00: "rgb(226, 246, 253)",
  $datavizAquaBlueVivid01: "rgb(197, 238, 251)",
  $datavizAquaBlueVivid02: "rgb(159, 226, 249)",
  $datavizAquaBlueVivid03: "rgb(121, 215, 246)",
  $datavizAquaBlueVivid04: "rgb(82, 204, 244)",
  $datavizAquaBlueVivid05: "rgb(44, 192, 242)",
  $datavizAquaBlueVivid06: "rgb(15, 176, 230)",
  $datavizAquaBlueVivid07: "rgb(12, 147, 192)",
  $datavizAquaBlueVivid08: "rgb(10, 118, 153)",
  $datavizAquaBlueVivid09: "rgb(7, 88, 115)",
  $datavizPurpleVivid10: "rgb(46, 3, 89)",
  $datavizPurpleVivid11: "rgb(36, 2, 69)",
  $datavizPurpleVivid12: "rgb(26, 2, 49)",
  $datavizPurpleVivid13: "rgb(15, 1, 30)",
  $datavizPurpleVivid00: "rgb(240, 225, 254)",
  $datavizPurpleVivid01: "rgb(224, 196, 253)",
  $datavizPurpleVivid02: "rgb(204, 156, 252)",
  $datavizPurpleVivid03: "rgb(184, 116, 251)",
  $datavizPurpleVivid04: "rgb(163, 77, 249)",
  $datavizPurpleVivid05: "rgb(143, 37, 248)",
  $datavizPurpleVivid06: "rgb(122, 7, 237)",
  $datavizPurpleVivid07: "rgb(102, 6, 198)",
  $datavizPurpleVivid08: "rgb(82, 5, 158)",
  $datavizPurpleVivid09: "rgb(61, 4, 119)",
  $staticBackgroundStandard: "rgb(255,255,255)",
  $staticBackgroundStrong: "rgb(239,239,239)",
  $staticBackgroundWeak: "rgb(245,245,245)",
  $staticBackgroundInverseStandard: "rgb(26,26,26)",
  $staticBackgroundInverseStrong: "rgb(13,13,13)",
  $staticBackgroundInverseWeak: "rgb(31,31,31)",
  $staticBackgroundSentimentNegative: "rgba(218,37,47, 0.08)",
  $staticBackgroundSentimentPositive: "rgba(70,183,96, 0.12)",
  $staticBackgroundSentimentNotice: "rgba(228,180,48, 0.16)",
  $staticBackgroundSentimentInfo: "rgba(28,105,232, 0.1)",
  $staticBackgroundSentimentNeutral: "rgba(26,26,26, 0.08)",
  $staticBackgroundSentimentInverseNegative: "rgb(218,37,47)",
  $staticBackgroundSentimentInversePositive: "rgb(70,183,96)",
  $staticBackgroundSentimentInverseNotice: "rgb(228,180,48)",
  $staticBackgroundSentimentInverseInfo: "rgba(18,88,210, 0.9)",
  $staticBackgroundSentimentInverseNeutral: "rgb(26,26,26)",
  $staticDividerStandard: "rgba(0,0,0, 0.12)",
  $staticDividerStrong: "rgba(0,0,0, 0.16)",
  $staticDividerWeak: "rgba(0,0,0, 0.08)",
  $staticDividerInverseStandard: "rgba(255,255,255, 0.32)",
  $staticDividerInverseStrong: "rgba(255,255,255, 0.48)",
  $staticDividerInverseWeak: "rgba(255,255,255, 0.24)",
  $staticTextStandard: "rgb(61,61,61)",
  $staticTextStrong: "rgb(0,0,0)",
  $staticTextWeak: "rgb(108,108,108)",
  $staticTextInverseStandard: "rgb(239,239,239)",
  $staticTextInverseStrong: "rgb(255,255,255)",
  $staticTextInverseWeak: "rgb(204,204,204)",
  $staticTextSentimentNegative: "rgb(197,35,43)",
  $staticTextSentimentPositive: "rgb(42,126,61)",
  $staticTextSentimentNotice: "rgb(134,105,30)",
  $staticTextSentimentInfo: "rgb(18,88,210)",
  $staticTextSentimentNeutral: "rgb(61,61,61)",
  $staticTextSentimentInverseNegative: "rgb(246,195,199)",
  $staticTextSentimentInversePositive: "rgb(177,229,191)",
  $staticTextSentimentInverseNotice: "rgb(255,228,156)",
  $staticTextSentimentInverseInfo: "rgb(156,192,247)",
  $staticTextSentimentInverseNeutral: "rgb(204,204,204)",
  $interactiveFillPrimaryEnabled: "rgb(28,105,232)",
  $interactiveFillPrimaryHover: "rgb(18,88,210)",
  $interactiveFillPrimaryPressed: "rgb(14,73,180)",
  $interactiveFillPrimaryDisabled: "rgb(214,214,214)",
  $interactiveFillPrimaryOnPrimary: "rgb(255,255,255)",
  $interactiveFillPrimaryOnDisabled: "rgb(143,143,143)",
  $interactiveFillSecondaryEnabled: "rgb(20,20,20)",
  $interactiveFillSecondaryHover: "rgb(41,41,41)",
  $interactiveFillSecondaryPressed: "rgb(69,71,73)",
  $interactiveFillSecondaryDisabled: "rgb(214,214,214)",
  $interactiveFillSecondaryOnSecondary: "rgb(255,255,255)",
  $interactiveFillSecondaryOnDisabled: "rgb(143,143,143)",
  $interactiveFillTertiaryEnabled: "rgba(0,0,0, 0.06)",
  $interactiveFillTertiaryHover: "rgba(0,0,0, 0.12)",
  $interactiveFillTertiaryPressed: "rgba(0,0,0, 0.2)",
  $interactiveFillTertiaryDisabled: "rgb(245,245,245)",
  $interactiveFillTertiaryOnTertiary: "rgb(82,82,82)",
  $interactiveFillTertiaryOnDisabled: "rgb(143,143,143)",
  $interactiveFillInverseEnabled: "rgb(255,255,255)",
  $interactiveFillInverseHover: "rgb(239,239,239)",
  $interactiveFillInversePressed: "rgb(214,214,214)",
  $interactiveFillInverseDisabled: "rgb(108,108,108)",
  $interactiveFillInverseOnInverse: "rgb(82,82,82)",
  $interactiveFillInverseOnDisabled: "rgb(204,204,204)",
  $interactiveFillDangerEnabled: "rgb(218,37,47)",
  $interactiveFillDangerHover: "rgb(197,35,43)",
  $interactiveFillDangerPressed: "rgb(170,30,36)",
  $interactiveFillDangerDisabled: "rgb(214,214,214)",
  $interactiveFillDangerOnDanger: "rgb(255,255,255)",
  $interactiveFillDangerOnDisabled: "rgb(143,143,143)",
  $interactiveOverlayPrimaryEnabled: "rgba(28,105,232, 0)",
  $interactiveOverlayPrimaryHover: "rgba(28,105,232, 0.06)",
  $interactiveOverlayPrimaryPressed: "rgba(28,105,232, 0.12)",
  $interactiveOverlayPrimarySelectedEnabled: "rgba(28,105,232, 0.08)",
  $interactiveOverlayPrimarySelectedHover: "rgba(28,105,232, 0.14)",
  $interactiveOverlayPrimarySelectedPressed: "rgba(28,105,232, 0.18)",
  $interactiveOverlaySecondaryEnabled: "rgba(0,0,0, 0)",
  $interactiveOverlaySecondaryHover: "rgba(0,0,0, 0.05)",
  $interactiveOverlaySecondaryPressed: "rgba(0,0,0, 0.09)",
  $interactiveOverlaySecondarySelectedEnabled: "rgba(0,0,0, 0.08)",
  $interactiveOverlaySecondarySelectedHover: "rgba(0,0,0, 0.13)",
  $interactiveOverlaySecondarySelectedPressed: "rgba(0,0,0, 0.16)",
  $interactiveOverlayInverseEnabled: "rgba(255,255,255, 0)",
  $interactiveOverlayInverseHover: "rgba(255,255,255, 0.04)",
  $interactiveOverlayInversePressed: "rgba(255,255,255, 0.12)",
  $interactiveOverlayInverseSelectedEnabled: "rgba(255,255,255, 0.1)",
  $interactiveOverlayInverseSelectedHover: "rgba(255,255,255, 0.16)",
  $interactiveOverlayInverseSelectedPressed: "rgba(255,255,255, 0.24)",
  $interactiveOutlinePrimaryEnabled: "rgb(191,216,250)",
  $interactiveOutlinePrimaryHover: "rgb(156,192,247)",
  $interactiveOutlinePrimaryPressed: "rgb(106,162,244)",
  $interactiveOutlinePrimaryDisabled: "rgb(217,232,253)",
  $interactiveOutlinePrimarySelectedEnabled: "rgb(28,105,232)",
  $interactiveOutlinePrimarySelectedHover: "rgb(18,88,210)",
  $interactiveOutlinePrimarySelectedPressed: "rgb(14,73,180)",
  $interactiveOutlineSecondaryEnabled: "rgb(214,214,214)",
  $interactiveOutlineSecondaryHover: "rgb(163,163,163)",
  $interactiveOutlineSecondaryPressed: "rgb(143,143,143)",
  $interactiveOutlineSecondaryDisabled: "rgb(214,214,214)",
  $interactiveOutlineSecondarySelectedEnabled: "rgb(0,0,0)",
  $interactiveOutlineSecondarySelectedHover: "rgb(69,71,73)",
  $interactiveOutlineSecondarySelectedPressed: "rgb(61,61,61)",
  $interactiveOutlineInverseEnabled: "rgb(108,108,108)",
  $interactiveOutlineInverseHover: "rgb(143,143,143)",
  $interactiveOutlineInversePressed: "rgb(153,153,153)",
  $interactiveOutlineInverseDisabled: "rgb(82,82,82)",
  $interactiveOutlineInverseSelectedEnabled: "rgb(163,163,163)",
  $interactiveOutlineInverseSelectedHover: "rgb(204,204,204)",
  $interactiveOutlineInverseSelectedPressed: "rgb(214,214,214)",
  $interactiveOutlineDangerEnabled: "rgb(231,71,80)",
  $interactiveOutlineDangerHover: "rgb(218,37,47)",
  $interactiveOutlineDangerPressed: "rgb(197,35,43)",
  $interactiveOutlineDangerDisabled: "rgb(214,214,214)"
};
const space = {
  $0: "0px",
  $1: "4px",
  $2: "8px",
  $3: "12px",
  $4: "16px",
  $5: "20px",
  $6: "24px",
  $7: "28px",
  $8: "32px",
  $9: "36px",
  $10: "40px",
  $12: "48px",
  $14: "56px",
  $16: "64px",
  $18: "72px",
  $20: "80px",
  $24: "96px",
  $28: "112px",
  $32: "128px",
  $36: "144px",
  $40: "160px",
  $48: "192px",
  $56: "224px",
  $64: "256px",
  $72: "288px",
  $80: "320px"
};
const sizes = {
  $0: "0px",
  $1: "4px",
  $2: "8px",
  $3: "12px",
  $4: "16px",
  $5: "20px",
  $6: "24px",
  $7: "28px",
  $8: "32px",
  $9: "36px",
  $10: "40px",
  $12: "48px",
  $14: "56px",
  $16: "64px",
  $18: "72px",
  $20: "80px",
  $24: "96px",
  $28: "112px",
  $32: "128px",
  $36: "144px",
  $40: "160px",
  $48: "192px",
  $56: "224px",
  $64: "256px",
  $72: "288px",
  $80: "320px"
};
const fonts = {
  $display: "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
  $text: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
  $mono: "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace"
};
const fontWeights = {
  $regular: 400,
  $bold: 600
};
const fontSizes = {};
const lineHeights = {};
const letterSpacings = {};
const typography = {
  $displayLarge: {
    "mobile": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "3.5rem",
      "lineHeight": 1.0357142857142858,
      "fontWeight": 500,
      "letterSpacing": "-0.012em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "4.5rem",
      "lineHeight": 1.0277777777777777,
      "fontWeight": 500,
      "letterSpacing": "-0.018em",
      "fontFeatureSettings": ""
    }
  },
  $displayMedium: {
    "mobile": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "3rem",
      "lineHeight": 1.0416666666666667,
      "fontWeight": 500,
      "letterSpacing": "-0.01em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "3.5rem",
      "lineHeight": 1.0357142857142858,
      "fontWeight": 500,
      "letterSpacing": "-0.016em",
      "fontFeatureSettings": ""
    }
  },
  $displaySmall: {
    "mobile": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "2rem",
      "lineHeight": 1.0625,
      "fontWeight": 500,
      "letterSpacing": "-0.008em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "3rem",
      "lineHeight": 1.0416666666666667,
      "fontWeight": 500,
      "letterSpacing": "-0.014em",
      "fontFeatureSettings": ""
    }
  },
  $headingLarge: {
    "mobile": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.75rem",
      "lineHeight": 1.0714285714285714,
      "fontWeight": 500,
      "letterSpacing": "-0.006em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "2.125rem",
      "lineHeight": 1.0588235294117647,
      "fontWeight": 500,
      "letterSpacing": "-0.014em",
      "fontFeatureSettings": ""
    }
  },
  $headingMedium: {
    "mobile": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.5rem",
      "lineHeight": 1.0833333333333333,
      "fontWeight": 500,
      "letterSpacing": "-0.004em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.625rem",
      "lineHeight": 1.0769230769230769,
      "fontWeight": 500,
      "letterSpacing": "-0.012em",
      "fontFeatureSettings": ""
    }
  },
  $headingSmall: {
    "mobile": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.25rem",
      "lineHeight": 1.1,
      "fontWeight": 500,
      "letterSpacing": "-0.003em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter Display', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.25rem",
      "lineHeight": 1.1,
      "fontWeight": 500,
      "letterSpacing": "-0.01em",
      "fontFeatureSettings": ""
    }
  },
  $labelLarge: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.125rem",
      "lineHeight": 1.1111111111111112,
      "fontWeight": 400,
      "letterSpacing": "-0.0026em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.125rem",
      "lineHeight": 1.1111111111111112,
      "fontWeight": 400,
      "letterSpacing": "-0.0026em",
      "fontFeatureSettings": ""
    }
  },
  $labelLargeBold: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.125rem",
      "lineHeight": 1.1111111111111112,
      "fontWeight": 530,
      "letterSpacing": "-0.0026em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.125rem",
      "lineHeight": 1.1111111111111112,
      "fontWeight": 530,
      "letterSpacing": "-0.0026em",
      "fontFeatureSettings": ""
    }
  },
  $labelMedium: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1rem",
      "lineHeight": 1.125,
      "fontWeight": 400,
      "letterSpacing": "-0.0018em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1rem",
      "lineHeight": 1.125,
      "fontWeight": 400,
      "letterSpacing": "-0.0018em",
      "fontFeatureSettings": ""
    }
  },
  $labelMediumBold: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1rem",
      "lineHeight": 1.125,
      "fontWeight": 530,
      "letterSpacing": "-0.0018em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1rem",
      "lineHeight": 1.125,
      "fontWeight": 530,
      "letterSpacing": "-0.0018em",
      "fontFeatureSettings": ""
    }
  },
  $labelSmall: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.875rem",
      "lineHeight": 1.1428571428571428,
      "fontWeight": 400,
      "letterSpacing": "-0.0009em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.875rem",
      "lineHeight": 1.1428571428571428,
      "fontWeight": 400,
      "letterSpacing": "-0.0009em",
      "fontFeatureSettings": ""
    }
  },
  $labelSmallBold: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.875rem",
      "lineHeight": 1.1428571428571428,
      "fontWeight": 530,
      "letterSpacing": "-0.0009em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.875rem",
      "lineHeight": 1.1428571428571428,
      "fontWeight": 530,
      "letterSpacing": "-0.0009em",
      "fontFeatureSettings": ""
    }
  },
  $paragraphLarge: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.125rem",
      "lineHeight": 1.3333333333333333,
      "fontWeight": 400,
      "letterSpacing": "-0.0026em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.125rem",
      "lineHeight": 1.3333333333333333,
      "fontWeight": 400,
      "letterSpacing": "-0.0026em",
      "fontFeatureSettings": ""
    }
  },
  $paragraphLargeBold: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.125rem",
      "lineHeight": 1.3333333333333333,
      "fontWeight": 600,
      "letterSpacing": "-0.0026em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1.125rem",
      "lineHeight": 1.3333333333333333,
      "fontWeight": 600,
      "letterSpacing": "-0.0026em",
      "fontFeatureSettings": ""
    }
  },
  $paragraphMedium: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1rem",
      "lineHeight": 1.25,
      "fontWeight": 400,
      "letterSpacing": "-0.0018em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1rem",
      "lineHeight": 1.25,
      "fontWeight": 400,
      "letterSpacing": "-0.0018em",
      "fontFeatureSettings": ""
    }
  },
  $paragraphMediumBold: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1rem",
      "lineHeight": 1.25,
      "fontWeight": 600,
      "letterSpacing": "-0.0018em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "1rem",
      "lineHeight": 1.25,
      "fontWeight": 600,
      "letterSpacing": "-0.0018em",
      "fontFeatureSettings": ""
    }
  },
  $paragraphSmall: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.875rem",
      "lineHeight": 1.2857142857142858,
      "fontWeight": 400,
      "letterSpacing": "-0.0009em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.875rem",
      "lineHeight": 1.2857142857142858,
      "fontWeight": 400,
      "letterSpacing": "-0.0009em",
      "fontFeatureSettings": ""
    }
  },
  $paragraphSmallBold: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.875rem",
      "lineHeight": 1.2857142857142858,
      "fontWeight": 600,
      "letterSpacing": "-0.006em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.875rem",
      "lineHeight": 1.2857142857142858,
      "fontWeight": 600,
      "letterSpacing": "-0.006em",
      "fontFeatureSettings": ""
    }
  },
  $numberLarge: {
    "mobile": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "1.25rem",
      "lineHeight": 1.1,
      "fontWeight": 400,
      "letterSpacing": "-0.05em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    },
    "desktop": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "1.125rem",
      "lineHeight": 1.1111111111111112,
      "fontWeight": 400,
      "letterSpacing": "-0.05em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    }
  },
  $numberLargeBold: {
    "mobile": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "1.25rem",
      "lineHeight": 1.1,
      "fontWeight": 600,
      "letterSpacing": "-0.05em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    },
    "desktop": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "1.125rem",
      "lineHeight": 1.1111111111111112,
      "fontWeight": 600,
      "letterSpacing": "-0.05em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    }
  },
  $numberMedium: {
    "mobile": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "1.125rem",
      "lineHeight": 1.1111111111111112,
      "fontWeight": 400,
      "letterSpacing": "-0.05em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    },
    "desktop": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "1rem",
      "lineHeight": 1.125,
      "fontWeight": 400,
      "letterSpacing": "-0.05em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    }
  },
  $numberMediumBold: {
    "mobile": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "1.125rem",
      "lineHeight": 1.1111111111111112,
      "fontWeight": 600,
      "letterSpacing": "-0.05em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    },
    "desktop": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "1rem",
      "lineHeight": 1.125,
      "fontWeight": 600,
      "letterSpacing": "-0.05em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    }
  },
  $numberSmall: {
    "mobile": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "1rem",
      "lineHeight": 1.125,
      "fontWeight": 400,
      "letterSpacing": "-0.05em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    },
    "desktop": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "0.875rem",
      "lineHeight": 1.1428571428571428,
      "fontWeight": 400,
      "letterSpacing": "-0.04em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    }
  },
  $numberSmallBold: {
    "mobile": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "1rem",
      "lineHeight": 1.125,
      "fontWeight": 600,
      "letterSpacing": "-0.05em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    },
    "desktop": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "0.875rem",
      "lineHeight": 1.1428571428571428,
      "fontWeight": 600,
      "letterSpacing": "-0.04em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    }
  },
  $numberXsmall: {
    "mobile": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "0.875rem",
      "lineHeight": 1.1428571428571428,
      "fontWeight": 400,
      "letterSpacing": "-0.04em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    },
    "desktop": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "0.75rem",
      "lineHeight": 1.1666666666666667,
      "fontWeight": 400,
      "letterSpacing": "-0.04em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    }
  },
  $numberXsmallBold: {
    "mobile": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "0.875rem",
      "lineHeight": 1.1428571428571428,
      "fontWeight": 600,
      "letterSpacing": "-0.04em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    },
    "desktop": {
      "fontFamily": "'Inter', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      "fontSize": "0.75rem",
      "lineHeight": 1.1666666666666667,
      "fontWeight": 600,
      "letterSpacing": "-0.04em",
      "fontFeatureSettings": "'lnum', 'tnum', 'ss01'"
    }
  },
  $captionMedium: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.875rem",
      "lineHeight": 1.1428571428571428,
      "fontWeight": 400,
      "letterSpacing": 0,
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.75rem",
      "lineHeight": 1.1666666666666667,
      "fontWeight": 400,
      "letterSpacing": "0.01em",
      "fontFeatureSettings": ""
    }
  },
  $captionMediumBold: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.875rem",
      "lineHeight": 1.1428571428571428,
      "fontWeight": 600,
      "letterSpacing": 0,
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.75rem",
      "lineHeight": 1.1666666666666667,
      "fontWeight": 600,
      "letterSpacing": "0.01em",
      "fontFeatureSettings": ""
    }
  },
  $captionSmall: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.75rem",
      "lineHeight": 1.1666666666666667,
      "fontWeight": 400,
      "letterSpacing": "0.002em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.625rem",
      "lineHeight": 1.2,
      "fontWeight": 400,
      "letterSpacing": "0.02em",
      "fontFeatureSettings": ""
    }
  },
  $captionSmallBold: {
    "mobile": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.75rem",
      "lineHeight": 1.1666666666666667,
      "fontWeight": 600,
      "letterSpacing": "0.002em",
      "fontFeatureSettings": ""
    },
    "desktop": {
      "fontFamily": "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'",
      "fontSize": "0.625rem",
      "lineHeight": 1.2,
      "fontWeight": 600,
      "letterSpacing": "0.02em",
      "fontFeatureSettings": ""
    }
  }
};
const radii = {
  $containerLarge: "20px",
  $containerMedium: "16px",
  $containerNone: "0",
  $containerSmall: "12px",
  $controlLarge: "8px",
  $controlMedium: "6px",
  $controlNone: "0",
  $controlPill: "100vmax",
  $controlSmall: "4px",
  $deprecatedFull: "9999px",
  $deprecatedLarge: "24px",
  $deprecatedMedium: "16px",
  $deprecatedNone: "0",
  $deprecatedRound: "50%",
  $deprecatedSmall: "8px",
  $deprecatedXSmall: "4px",
  $sheetLarge: "28px",
  $sheetMedium: "24px",
  $sheetNone: "0"
};
const shadows = {
  $focusInside: "inset 0px 0px 0px 1px rgb(0, 0, 0), inset 0px 0px 0px 2px rgb(255, 255, 255)",
  $focusOutside: "0px 0px 0px 2px rgb(255, 255, 255), 0px 0px 0px 4px rgb(0, 0, 0)",
  $interactiveElevationHigh: "0px 2px 4px 0px rgba(0, 0, 0, 0.05), 0px 3px 5px 0px rgba(0, 0, 0, 0.05), 0px 4px 6px 0px rgba(0, 0, 0, 0.05), 0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
  $interactiveElevationLow: "0px 1px 1px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.1), 0px 0px 2px 0px rgba(0, 0, 0, 0.07)",
  $interactiveElevationMedium: "0px 1px 1px 0px rgba(0, 0, 0, 0.1), 0px 2px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 4px 0px rgba(0, 0, 0, 0.07), 0px 1px 4px 0px rgba(0, 0, 0, 0.08)",
  $staticElevationHigh: "0px 2px 4px 0px rgba(0, 0, 0, 0.03), 0px 6px 6px 0px rgba(0, 0, 0, 0.03), 0px 15px 20px 0px rgba(0, 0, 0, 0.03), 0px 30px 40px 0px rgba(0, 0, 0, 0.03), 0px 40px 70px 0px rgba(0, 0, 0, 0.03), 0px 4px 30px 0px rgba(0, 0, 0, 0.03), 0px 0px 8px 0px rgba(0, 0, 0, 0.03)",
  $staticElevationLow: "0px 1px 1px 0px rgba(0, 0, 0, 0.07), 0px 1px 2px 0px rgba(0, 0, 0, 0.08), 0px 2px 2px 0px rgba(0, 0, 0, 0.1), 0px 0px 8px 0px rgba(0, 0, 0, 0.05)",
  $staticElevationMedium: "0px 1px 1px 0px rgba(0, 0, 0, 0.05), 0px 2px 2px 0px rgba(0, 0, 0, 0.05), 0px 5px 5px 0px rgba(0, 0, 0, 0.05), 0px 10px 10px 0px rgba(0, 0, 0, 0.05), 0px 0px 8px 0px rgba(0, 0, 0, 0.05)"
};
const zIndices = {
  $elementsAndComponents: 1,
  $elementAndComponentDropDowns: 2e3,
  $secondaryNavigation: 3e3,
  $headerFooter: 4e3,
  $primaryNavigation: 5e3,
  $fullScreenFeatures: 6e3,
  $specialCases: 7e3,
  $popOvers: 8e3,
  $modalsDialogWindows: 8e3,
  $notifications: 9e3
};
const easings = {};
const durations = {};
const borderWidths = {};
const breakpointMap = {
  $2: 320,
  $3: 480,
  $4: 640,
  $5: 800,
  $6: 960,
  $7: 1120,
  $8: 1280,
  $9: 1440,
  $10: 1600,
  $11: 1760,
  $12: 1920
};
const breakpoints = (() => {
  const pixify = (n) => `${n}px`;
  const arr = Object.values(breakpointMap);
  const bps = arr.map(pixify);
  bps.$2 = pixify(arr[0]);
  bps.$3 = pixify(arr[1]);
  bps.$4 = pixify(arr[2]);
  bps.$5 = pixify(arr[3]);
  bps.$6 = pixify(arr[4]);
  bps.$7 = pixify(arr[5]);
  bps.$8 = pixify(arr[6]);
  bps.$9 = pixify(arr[7]);
  bps.$10 = pixify(arr[8]);
  bps.$11 = pixify(arr[9]);
  bps.$12 = pixify(arr[10]);
  return bps;
})();
const responsiveThresholds = {
  $desktop: "$5"
};
export {
  borderWidths,
  breakpoints,
  colors,
  durations,
  easings,
  fontSizes,
  fontWeights,
  fonts,
  letterSpacings,
  lineHeights,
  radii,
  responsiveThresholds,
  shadows,
  sizes,
  space,
  typography,
  zIndices
};
